var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelCustom = function SvgModelCustom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16 8.5a4.5 4.5 0 0 1-6.604 3.979L5.875 16 4 14.125l3.521-3.521a4.5 4.5 0 0 1 6.083-6.083L10.75 7.375l1.875 1.875 2.854-2.854A4.5 4.5 0 0 1 16 8.5Z"
  })));
};
export default SvgModelCustom;